import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import { fontFamily } from "@utils/styles/fonts";
import KYCFailed from "../../../assets/svg/KYCSetup/KYCStatus/Failed";
import KYCPartiallySuccess from "../../../assets/svg/KYCSetup/KYCStatus/PartiallySuccess";
import KYCProcessing from "../../../assets/svg/KYCSetup/KYCStatus/Processing";
import KYCSuccess from "../../../assets/svg/KYCSetup/KYCStatus/Success";

// Verification status banner. Same status model as before (NONE / PROCESSING /
// VERIFIED / REJECTED / PARTIALLY_VERIFIED) restyled as a rounded, tinted card
// consistent with the Onboarding status cards. Two extra app-derived states for
// the OLD-DB manual review flow (see index.js bannerStatus):
// UNDER_PARTNER_REVIEW (documents passed, awaiting the CP) and
// UNDER_ADMIN_REVIEW (CP approved, awaiting the admin) — "Congratulations" is
// reserved for a fully admin-approved KYC.
const KYCStatus = (props) => {
  const { statusText = "NONE", isAadharPanLinked = false } = props;

  const [data, setData] = useState(null);

  useEffect(() => {
    switch (statusText) {
      case "PROCESSING":
        setData({
          icon: KYCProcessing,
          bgColor: color.veryLightSkyBlue,
          borderColor: color.pacificBlue,
          titleColor: color.pacificBlue,
          title: "वेरिफिकेशन प्रोसेस में है",
          subTitle: "आपका वेरिफिकेशन अभी प्रोसेस में है I",
        });
        break;
      case "UNDER_PARTNER_REVIEW":
        setData({
          icon: KYCProcessing,
          bgColor: color.veryLightSkyBlue,
          borderColor: color.pacificBlue,
          titleColor: color.pacificBlue,
          title: "KYC रिव्यू में है",
          subTitle:
            "आपके डाक्यूमेंट्स वेरिफाई हो गए हैं I अब आपके CP द्वारा रिव्यू किया जा रहा है I",
        });
        break;
      case "UNDER_ADMIN_REVIEW":
        setData({
          icon: KYCProcessing,
          bgColor: color.veryLightSkyBlue,
          borderColor: color.pacificBlue,
          titleColor: color.pacificBlue,
          title: "KYC फाइनल रिव्यू में है",
          subTitle:
            "आपके CP ने अप्रूव कर दिया है I अब एडमिन द्वारा फाइनल रिव्यू किया जा रहा है I",
        });
        break;
      case "REJECTED":
        setData({
          icon: KYCFailed,
          bgColor: color.lightRed,
          borderColor: color.primary,
          titleColor: color.primary,
          title: "वेरिफिकेशन फेल्ड",
          subTitle: !isAadharPanLinked
            ? "आपका वेरिफिकेशन फेल हो गया है I आपका आधार और पैन लिंक नहीं है, कृपया अपने डाक्यूमेंट्स फिर से डालें I"
            : "आपका वेरिफिकेशन फेल हो गया है I कृपया अपने डाक्यूमेंट्स फिर से डालें I",
        });
        break;
      case "VERIFIED":
        setData({
          icon: KYCSuccess,
          bgColor: color.veryLightGreen,
          borderColor: color.plain_green,
          titleColor: color.plain_green,
          title: "Congratulations !",
          subTitle: "आपका KYC वेरिफाइड हो चुका है",
        });
        break;
      case "PARTIALLY_VERIFIED":
        setData({
          icon: KYCPartiallySuccess,
          bgColor: color.veryLightGreen,
          borderColor: color.plain_green,
          titleColor: color.plain_green,
          title: "केवल कुछ डाक्यूमेंट्स वेरिफाइड हुए",
          subTitle:
            "जिन डाक्यूमेंट्स का वेरिफिकेशन फेल हो गया है, उनको फिर से अपलोड करें I",
        });
        break;
      default:
        setData(null);
    }
  }, [statusText, isAadharPanLinked]);

  if (!data) {
    return null;
  }

  const { icon: Icon } = data;
  return (
    <View
      style={[
        styles.card,
        { backgroundColor: data.bgColor, borderColor: data.borderColor },
      ]}
    >
      <View style={styles.iconWrap}>
        <Icon />
      </View>
      <View style={styles.textWrap}>
        <Text style={[styles.title, { color: data.titleColor }]}>
          {data.title}
        </Text>
        <Text style={styles.subTitle}>{data.subTitle}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 12,
    padding: 12,
    marginTop: 4,
    marginBottom: 20,
  },
  iconWrap: {
    marginRight: 10,
  },
  textWrap: {
    flex: 1,
  },
  title: {
    fontFamily: fontFamily.bold,
    fontSize: 15,
    marginBottom: 2,
  },
  subTitle: {
    fontSize: 13,
    lineHeight: 18,
    color: color.Gray20,
  },
});

export default KYCStatus;
